<template>
<div>
    <p style="text-align: center; font-size: 16px"><b>Contact Request</b></p>
    <p>
        <b>Customer Name</b><br/>
        {{value.customer_name}}
    </p>

    <p
        v-if="pretty_customer_phone_number != null"
    >
        <v-row>
        <v-col>
            <b>Phone Number</b><br/>
            {{pretty_customer_phone_number}}
        </v-col>
        <v-col
            v-if="has_phone_validation_result"
            align="right"
        >
            <div
                style="height: 12px;"
            >
            </div>
            <m-phone-validation-chip
                :value="{ 'orig_result' : validations.phone }"
            />
        </v-col>
        </v-row>
    </p>

    <p
        v-if="has_ip_validation_result"
    >
        <b>IP Address</b><br/>
        {{validations.ip.ip}} &mdash; {{validations.ip.isp}}<br/>
        {{validations.ip.location}}
    </p>

    <p
        v-if="has(value.inbox_help_with)"
    >
        <b>Help With</b><br/>
        {{value.inbox_help_with}}
    </p>

    <p 
        v-if="has(value.message)"
    >
        <b>Message</b><br/>
        {{value.message}}
    </p>

    <p
        v-for="(extra_field, ex_index) in value.extra_fields"
        :key="ex_index"
    >
        <b>{{extra_field.text}}</b><br/>
        {{extra_field.value}}
    </p>

    <p 
        v-if="has(value.created_by)"
    >
        <b>Created By</b><br/>
        {{value.created_by.full_name}} ({{value.created_by.username}})
    </p>

    

    <p 
        v-if="has(value.submitted_from_url)"
    >
        <b>Submitted From</b><br/>
        <a v-bind:href='value.submitted_from_url' target="_blank">{{value.submitted_from_url}}</a>
    </p>

</div>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {
    props: {
        value: {
            type: Object,
            default: function () { return {}; }
        },

        full_message: {
            type: Object,
            default: function () { return {}; }
        }
    },

    data() {
        return {
        }
    },


    methods: 
    {
        has(value) 
        {
            if ( value == null ) return false;
            if ( typeof value === 'string' && value.trim().length == 0 ) return false;
            return true;
        },
    },

    computed: {
        pretty_customer_phone_number() {
            if ( this.value == null ) return null;
            if ( this.value.customer_endpoint == null ) return null;

            return E164.prettyPrintUsPhoneNumber(this.value.customer_endpoint);
        },

        has_phone_validation_result() {
            if ( this.validations == null || this.validations.phone == null ) 
                return false;
            
            return true;
        },

        has_ip_validation_result() {
            if ( this.validations == null || this.validations.ip == null ) 
                return false;
            
            return true;
        },

        validations() {
            let ret = this.$rc.getDeep(this.full_message,'data/extended_data/validation_result');
            if ( ret == null ) return {};
            return ret;
        },
    },
}
</script>


<style lang="scss" scoped>

</style>